import React from 'react'


const OldProductPrice = React.lazy(() => import("pages/OldProductPrice/pages/OldProductPricePage"))
const OldProductPriceAdd = React.lazy(() => import("pages/OldProductPrice/pages/OldProductPriceAdd"))
const OldProductPriceDetail = React.lazy(() => import("pages/OldProductPrice/pages/OldProductPriceDetail"))
const OldProductPriceEdit = React.lazy(() => import("pages/OldProductPrice/pages/OldProductPriceEdit"))


const OldProductPriceRoutes = [

    {
        path: "/old-product-price",
        exact: true,
        name: "Giá sản phẩm cũ",
        function: "SL_OLDPRODUCTPRICE_VIEW",
        component: OldProductPrice,
    },
    {
        path: "/old-product-price/add",
        exact: true,
        name: "Thêm mới",
        function: "SL_OLDPRODUCTPRICE_ADD",
        component: OldProductPriceAdd,
    },
    {
        path: "/old-product-price/detail/:id",
        exact: true,
        name: "Chi tiết",
        function: "SL_OLDPRODUCTPRICE_VIEW",
        component: OldProductPriceDetail,
    },
    {
        path: "/old-product-price/edit/:id",
        exact: true,
        name: "Chỉnh sửa",
        function: "SL_OLDPRODUCTPRICE_EDIT",
        component: OldProductPriceEdit,
    },

]

export default OldProductPriceRoutes
